import {
    displayCurrency,
    displayPercent,
    displayShortDate,
    displayShortDateShortYear
} from '../../utils/Format/Format';

const displayCurrencyFourDec = (v) => displayCurrency(v, 4);
const displayDividendCurrencyNineDec = (v) => displayCurrency(v, 9);

export const distributionScheduleUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }
    const {
        mutualFund: { dividendFrequency, capitalGainFrequency }
    } = gqlResult;

    const title = 'Distribution Schedule';
    const returnData = [
        {
            label: 'Capital Gains*',
            values: [
                {
                    val1:
                        capitalGainFrequency !== null
                            ? capitalGainFrequency
                            : 'Annual'
                }
            ]
        },
        {
            label: 'Dividends',
            values: [
                { val1: dividendFrequency !== null ? dividendFrequency : 'N/A' }
            ],
            showDefinition: false,
            definition: `The distribution of earnings to stockholders and shareholders. The per-share amount is decided by the board of directors. On individual stocks, dividends are usually paid quarterly. Mutual fund dividends are paid out of net income and may be distributed on a monthly, quarterly (March, June, September, and December) or annual basis.`
        }
    ];

    return { data: returnData, title };
};

export const capitalGainsUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }

    const {
        mutualFund: { capitalGainPayments }
    } = gqlResult;
    const title = 'Capital Gains';
    const headers = [
        'Date',
        'Short-Term Per Share Amount',
        'Long-Term Per Share Amount',
        'Reinvestment Price'
    ];
    const data = capitalGainPayments.map((ele) => ({
        label: displayShortDateShortYear(ele.capGainPayDate),
        values: [
            { 'short-term': displayCurrencyFourDec(ele.shortTermGain) },
            { 'long-term': displayCurrencyFourDec(ele.longTermGain) },
            {
                'reinvestment-price': displayCurrencyFourDec(
                    ele.capGainReinvestmentPrice
                )
            }
        ]
    }));
    return {
        data,
        headers,
        title
    };
};

export const dividendPaymentsUtil = (ticker) => (gqlResult) => {
    if (!gqlResult) {
        return null;
    }

    const {
        mutualFund: { dividendPayments }
    } = gqlResult;
    const headers = ['Date', 'Per Share Amount', 'Reinvestment Price'];

    // Hard-Coding for only 'PRNHX' as per US87730 - showing as in prod
    const data =
        ticker === 'PRNHX'
            ? [
                  {
                      label: '12/16/2009',
                      values: [
                          {
                              'per-share-amt': '$0.01'
                          },
                          {
                              'reinvestment-price': '$0.00'
                          }
                      ]
                  }
              ]
            : dividendPayments.map((ele) => ({
                  label: displayShortDate(ele.dividendPayDate),
                  values: [
                      {
                          'per-share-amt':
                              ele.dividendAmt && ele.dividendAmt.length !== 0
                                  ? displayDividendCurrencyNineDec(
                                        ele.dividendAmt
                                    )
                                  : '$0.0000'
                      },
                      {
                          'reinvestment-price':
                              ele.dividendReinvestmentPrice &&
                              ele.dividendReinvestmentPrice.length !== 0
                                  ? displayCurrencyFourDec(
                                        ele.dividendReinvestmentPrice
                                    )
                                  : '$0.00'
                      }
                  ]
              }));

    if (data.length === 0) {
        data.push({
            values: [
                { 'per-share-amt': '$0.0000' },
                { 'reinvestment-price': '$0.00' }
            ]
        });
    }

    return {
        data,
        headers
    };
};

export const alternativeMinimumTaxUtil = (gqlResult) => {
    if (!gqlResult) {
        return null;
    }

    const {
        mutualFund: { percentBondInvestedAMT, monthlyComponentsAsOfDate }
    } = gqlResult;
    const data = [
        {
            label:
                'Percentage of Fund Income subject to the Alternative Minimum Tax',
            values: [
                {
                    val: displayPercent(percentBondInvestedAMT)
                }
            ]
        }
    ];

    const asOfDate = displayShortDate(monthlyComponentsAsOfDate);

    return {
        data,
        asOfDate
    };
};
